import { Box, Button, Container, Paper, Typography } from '@mui/material';
import { useAuth } from './AuthProvider';

export const AuthErrorPage = () => {
  const { error } = useAuth();

  const handleRetry = () => {
    const authUrl = import.meta.env.VITE_AUTH_URL;
    if (authUrl) {
      window.location.href = `${authUrl}?return=${encodeURIComponent(window.location.origin)}`;
    } else {
      window.location.reload();
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h4" color="error" gutterBottom>
            Authentication Error
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {error || 'An error occurred during authentication. Please try again.'}
          </Typography>
          <Button variant="contained" color="primary" onClick={handleRetry}>
            Try Again
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};
